import React, { useCallback } from 'react';


import styles from './css/GuestHomePageV2.module.css';
import playerStyles from '../../../components/anchorComponents/SimpleVideoPlayer.module.css';
import TourCallToActionModal from './TourCallToActionModal';


const TOUR_VIDEOS = {
  general:
    'https://nnprod.us-north-3.mojocloud.com/data/anchors/promos/000/000/079/305/test-anchor-69-6d5dc6.mp4',
  audition:
    'https://nnprod.us-north-3.mojocloud.com/data/anchors/promos/000/000/079/305/test-anchor-69-7436b2.mp4',
  'naked news live':
    'https://nnprod.us-north-3.mojocloud.com/data/anchors/promos/000/000/079/305/test-anchor-69-20507a.mp4',
};

function TourVideo({ tourVideo }) {
  const [showModal, setShowModal] = React.useState(false);

  const handleVideoEnd = useCallback(() => {
    setShowModal(true);
  }, []);

  const handleVideoStart = useCallback(() => {
    setShowModal(false);
  }, []);

  const getSrc = useCallback(() => {
    if (!TOUR_VIDEOS[tourVideo]) {
      return TOUR_VIDEOS.general;
    }

    return TOUR_VIDEOS[tourVideo];
  }, [tourVideo]);

  return (
    <div
      className={styles.container}
    >
      <div className={styles.tourContainer}>
        <div className={styles.videoSection}>
          {showModal && <TourCallToActionModal />}
          <video
            autoPlay={true}
            className={`${styles.tourVideo} ${playerStyles.blurred}`}
            controls={true}
            loop={true}
            muted={true}
            playsInline={true}
            src={getSrc()}
            webkit-playsinline="true"
            onEnded={handleVideoEnd}
            onPlay={handleVideoStart}
          />
        </div>
      </div>
    </div>
  );
}

export default TourVideo;

TourVideo.defaultProps = { tourVideo: 'general' };
